import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
  Button,
} from '../../components/index';
import {
  buscaDestinatarios,
  // requestApagaPeriodosVigencia,
  // requestApagaRelEntidadesRppsUoInss,
  doGet,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
// import { msgsConfirmacaoEnte } from '../../utils/constants';
import FiltroPesquisaEnteFederativo from './FiltroPesquisaEnteFederativo';
import ModalAlerta from '../requerimentos/ModalAlerta';
import { manterApenasFiltro, formatarCnpj } from '../../utils/helpers';

class ConsultaEnteFederativo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      filtrosPesquisaCnpj: {},
      showModalAlerta: false,
    };
  }

  componentDidMount() {
    manterApenasFiltro('filtroEnteFederativo');
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    // this.realizaConsulta();
  }
  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRegistrosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'participantes-rpps',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
      this.setState({ filtrosPesquisaCnpj: this.state.filtrosConsulta });
      this.setState({ filtrosPesquisa: this.state.filtrosConsulta });
    } else {
      this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = { };
    if (atributosPesquisa['destinatario-rpps']) {
      atributos = { ...atributos, 'destinatario-rpps': atributosPesquisa['destinatario-rpps'] };
    }
    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: response.data,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Não existe cnpj para o ente federativo escolhido.',
            noContentSecondaryMessage: 'Informe um ente federativo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  colunasDefault = [
    {
      id: 'cnpjFormatado',
      label: 'CNPJ do RPPS',
    }, {
      id: 'dataConvenio',
      label: 'Data do Convênio',
    }, {
      id: 'numeroBancoFormatado',
      label: 'Banco',
    }, {
      id: 'numeroAgenciaFormatado',
      label: 'Agência',
    }, {
      id: 'numeroContaCorrenteFormatado',
      label: 'Conta Corrente',
    },
  ];

  showCadastroRppsAtualizacao = (participante) => {
    this.props.history.push(`/cadastros/entesFederativos/rpps/${participante.idParticipante}/atualizar-rpps`);
  }

  showCadastroNovoRpps = () => {
    const codigoEnte = this.state.filtrosPesquisaCnpj['destinatario-rpps'];
    this.setState(this.apagarPeriodosVigenciaRegimesProprios(), this.apagarListaUosInss());
    this.props.history.push(`/cadastros/entesFederativos/rpps/novo/${codigoEnte}`);
  }

  realizaConsultaCnpj = () => {
    const codigoEnte = this.state.filtrosPesquisaCnpj['destinatario-rpps'];
    this.setState(this.recuperarCnpjDoEnte(codigoEnte));
  }

  recuperarCnpjDoEnte = (paramCodigoEnte) => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      doGet(
        'participantes-rpps',
        this.tratarSucesso,
        this.tratarErro,
        {
          codigo: paramCodigoEnte,
        },
      );
    }
  }

  montaAcaoCadastroRpps = (row, hint) => (
    <Button
      hint={hint}
      icon="ico-doc-pencil"
      mini
      onClick={() => this.showCadastroRppsAtualizacao(row)}
    />
  );

  createActionColumn = (cell, row) => {
    const hint = 'Alterar regime próprio';
    return this.montaAcaoCadastroRpps(row, hint);
  };

  montaColunas = () => {
    const participanteTableHeader = this.colunasDefault.slice();
    participanteTableHeader.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    return participanteTableHeader;
  }

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  alterarPagina = (pagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    const listaRegistrosIndexada = this.state.listaRegistrosIndexada.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.acoes = i;
      if (itemIndexado.cnpj) {
        itemIndexado.cnpjFormatado = formatarCnpj(itemIndexado.cnpj);
      }
      if (itemIndexado.numeroAgencia) {
        let dvAg = itemIndexado.dvAgencia;
        if (dvAg === undefined) {
          dvAg = '';
        }
        itemIndexado.numeroAgenciaFormatado = `${itemIndexado.numeroAgencia}${dvAg ? `-${dvAg}` : ''}`;
      }
      if (itemIndexado.numeroContaCorrente) {
        let dvConta = itemIndexado.dvContaCorrente;
        if (dvConta === undefined) {
          dvConta = '';
        }
        itemIndexado.numeroContaCorrenteFormatado = `${itemIndexado.numeroContaCorrente}${dvConta ? `-${dvConta}` : ''}`;
      }

      if (itemIndexado.numeroBanco) {
        let codBanco = itemIndexado.numeroBanco;
        if (codBanco === undefined) {
          codBanco = '';
        }
        if (codBanco.length === 1) {
          codBanco = `00${itemIndexado.numeroBanco}`;
        }
        let nome = itemIndexado.nomeBanco;
        if (nome === undefined) {
          nome = '';
        }
        itemIndexado.numeroBancoFormatado = `${codBanco}${nome ? `-${nome}` : ''}`;
      }
      return itemIndexado;
    });

    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.showCadastroNovoRpps}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    const options = {
      noDataText: 'Nenhum regime próprio a ser exibido',
      hideSizePerPage: true,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const participanteTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroPesquisaEnteFederativo
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            destinatarios={this.props.destinatarios}
            list={listaRegistrosIndexada}
            tipoConsulta={this.getTipoConsulta()}
            listaRegistrosIndexadaAtualizada={this.state.listaRegistrosIndexadaAtualizada}
          />
          <Table
            legend="Participante da compensação"
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={participanteTableHeader}
            pagination
            remote
          />
          {modalAlerta}
        </DtpContentContainer>
      )
    );
  }
}

ConsultaEnteFederativo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

ConsultaEnteFederativo.defaultProps = {
  match: null,
  destinatarios: [],
};
const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
});

export default connect(mapStateToProps)(ConsultaEnteFederativo);



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaEnteFederativo.jsx